"use client"
/* */
const toArray = (val) => Array.isArray(val) ? val : [val];

export { toArray };
//# sourceMappingURL=toArray.mjs.map
